export default class ConversationEndpoints {
  static readonly CREATE_CONVERSATION = "/conversations/";
  static readonly GET_CONVERSATIONS = (workspaceId: string, offset: number = 0, limit: number = 10) =>
    `/conversations/?workspace_id=${workspaceId}&offset=${offset}&limit=${limit}`;
  static readonly POST_MESSAGE = (conversationId: string) => `/conversations/${conversationId}/messages/`;
  static readonly GET_MESSAGES = (conversationId: string) => `/conversations/${conversationId}/messages/`;
  static readonly GET_MESSAGE_VOCS = (
    conversationId: string,
    messageId: string,
    offset: number = 0,
    limit: number = 10,
  ) => `/conversations/${conversationId}/messages/${messageId}/vocs/?offset=${offset}&limit=${limit}`;
  static readonly DOWNLOAD_MESSAGE_VOCS_CSV = (conversationId: string, messageId: string) =>
    `/conversations/${conversationId}/messages/${messageId}/vocs/download/`;
}
